// extracted by mini-css-extract-plugin
export default {"divider":"vv-z"};